<div class="animated fadeIn container-fluid">
    <form [formGroup]="form">
        <h4>{{ title }} Aforo</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos del Aforo
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="IdComunidadAutonoma">Comunidad Autónoma</label>
                                            <ng-select appendTo="body"
                                                       loadingText="Cargando..."
                                                       [items]="comunidadesAutonomas"
                                                       placeholder="-- Seleccione una Comunidad Autónoma --"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdComunidadAutonoma"
                                                       [ngClass]="displayFieldCssNgSelect('IdComunidadAutonoma')"
                                                       (change)="onSelectComunidadAutonoma($event)"
                                                       notFoundText="Comunidad Autónoma no encontrada"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdComunidadAutonoma','required')">
                                                La Comunidad Autónoma es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="IdProvincia">Provincia</label>
                                            <ng-select appendTo="body"
                                                       loadingText="Cargando..."
                                                       [items]="provincias"
                                                       [readonly]="!provincias || provincias.length === 0"
                                                       placeholder="-- Seleccione una Provincia --"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdProvincia"
                                                       [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                                       (change)="onSelectProvincia($event)"
                                                       notFoundText="Provincia no encontrada"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                                La Provincia es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="IdRecinto">Recinto</label>
                                            <ng-select appendTo="body"
                                                       loadingText="Cargando..."
                                                       [items]="recintos"
                                                       [readonly]="!recintos || recintos.length === 0"
                                                       placeholder="-- Seleccione una Recinto --"
                                                       bindLabel="Titular"
                                                       bindValue="Id"
                                                       formControlName="IdRecinto"
                                                       [ngClass]="displayFieldCssNgSelect('IdRecinto')"
                                                       (change)="onSelectRecinto($event)"
                                                       notFoundText="Recinto no encontrado"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Titular }}">{{ item.Titular }}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdRecinto','required')">
                                                El Recinto es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="IdCultivo">Cultivo</label>
                                            <ng-select appendTo="body"
                                                       loadingText="Cargando..."
                                                       [items]="cultivos"
                                                       [readonly]="!cultivos || cultivos.length === 0"
                                                       placeholder="-- Seleccione una Cultivo --"
                                                       bindLabel="Variedad"
                                                       bindValue="Id"
                                                       formControlName="IdCultivo"
                                                       [ngClass]="displayFieldCssNgSelect('IdCultivo')"
                                                       notFoundText="Cultivo no encontrado"
                                                       clearAllText="Eliminar selección"
                                                       (change)="onChangeCultivo($event.Id)">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Variedad }}">{{ item.Variedad }}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCultivo','required')">
                                                El Cultivo es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="Descripcion">Descripción</label>
                                            <input formControlName="Descripcion" name="Descripcion" maxlength="100" class="form-control" id="Descripcion" type="text" [value]="calcularDescripcionCompleta()" [ngClass]="displayFieldCss('Descripcion')" readonly>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Descripcion','required')">
                                                La Descripción es obligatoria. Esta estará compuesta por la Variedad del Cultivo, el Año y el Mes seleccionados. Tendrá que rellenar esos campos para que la Descripción se complete
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="Anyo">Año</label>
                                            <input formControlName="Anyo" name="Anyo" [min]="currentYear" max="9999" class="form-control" id="Anyo" type="number" value="" [ngClass]="displayFieldCss('Anyo')" (change)="onChangeAnyo()">
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Anyo','required')" step="1" pattern="\d*">
                                                El Año es obligatorio
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Anyo','max')">
                                                El Año debe tener 4 dígitos
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Anyo','min')">
                                                El Año debe ser el actual o superior
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="Mes">Mes</label>
                                            <p-calendar formControlName="Mes"
                                                        [showIcon]="true"
                                                        view="month"
                                                        dateFormat="MM"
                                                        [readonlyInput]="true"
                                                        (onSelect)="onMonthSelect($event)"/>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Mes','required')">
                                                El Mes es obligatorio
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="KgsProduccionEstimada">Producción estimada (Kg)</label>
                                            <input formControlName="KgsProduccionEstimada" name="KgsProduccionEstimada" maxlength="100" class="form-control" id="KgsProduccionEstimada" type="number" value="" [ngClass]="displayFieldCss('KgsProduccionEstimada')">
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('KgsProduccionEstimada','required')">
                                                La Producción estimada en Kg es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="KgsProduccionReal">Producción real (Kg)</label>
                                            <input formControlName="KgsProduccionReal" name="KgsProduccionReal" maxlength="100" class="form-control" id="KgsProduccionReal" type="number" value="" [ngClass]="displayFieldCss('KgsProduccionReal')" readonly>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('KgsProduccionReal','required')">
                                                La Producción real en Kg es obligatoria
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </form>
</div>
